
<!-- Copyright (c) 2019-2023 Cigent Technology Inc. All Rights Reserved. -->
<h2 mat-dialog-title>{{'edit-key-dialog.title' | translate}}</h2>

<mat-dialog-content>

    <form [formGroup]="fg">

        <div>
            <mat-form-field appearance="outline">
                <mat-label>{{'key-management.upload-key-dialog.key-name' | translate}}</mat-label>
                <input matInput formControlName="name" name="name" maxlength="255">
            </mat-form-field>
        </div>

        <div>
            <mat-form-field appearance="outline">
                <mat-label>{{'key-management.upload-key-dialog.key-expires' | translate}}</mat-label>
                <input matInput formControlName="expirationDate" name="expirationDate" [matDatepicker]="picker">
                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
            </mat-form-field>
        </div>

    </form>

</mat-dialog-content>

<mat-dialog-actions class="button-wrapper">
    <button mat-raised-button (click)="onClickCancel()">{{'CANCEL' | translate}}</button>
    <button mat-raised-button [disabled]="disableOKButton" (click)="onClickOK()">{{'OK' | translate}}</button>
</mat-dialog-actions>
